import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { PARTNERS_ROUTE_PATHS } from './config';

export const PARTNERS_ROUTES: TApplicationRoute[] = [
  {
    id: 'partners-list',
    path: PARTNERS_ROUTE_PATHS.partners,
    component: lazy(() => import('./pages/find-page')),
    layout: 'default',
    permissions: { scopes: ['partners-platform'] },
    menu: {
      title: 'pages.partnersPlatform.partners.title',
    },
  },
  {
    id: 'partner-detail',
    path: PARTNERS_ROUTE_PATHS.partnerDetail,
    component: lazy(() => import('./pages/partner-detail-page')),
    layout: 'default',
    permissions: { scopes: ['partners-platform'] },
  },
];
